import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { INavData } from '@coreui/angular';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { RestService } from '../../rest.service';
import { UserIdleService } from 'angular-user-idle';
import { NotificationService } from '../../notification.service';
import { environment } from '../../../environments/environment.prod';
@Component({
  selector: 'app-dashboard',
  templateUrl: './default-layout.component.html',
  styleUrls: ['./default-layout.component.css'],
})

export class DefaultLayoutComponent implements OnInit {

  @ViewChild('notificationPanel') public notificationPanel: ModalDirective;
  @ViewChild('idleModal') public idleModal: ModalDirective;
  public sidebarMinimized = false;
  public sideNav: INavData[] = [];
  public menu = this.sideNav;
  public roleId: any;
  public navItems = this.sideNav;
  public name: string;
  public email: any;
  public employeeId: string;
  public departmentName: string;
  public roleName: string;
  notificationCount: any = [];
  notificationList: any = [];
  profileName: string;
  public currentDate = new Date();
  timer: any;
  files: any = [];
  fileName: any;
  downloadUrl: any;
  toggleMinimize(e) {
    this.sidebarMinimized = e;
  }
  constructor(private router: Router, private restService: RestService, private userIdle: UserIdleService,
    private notify: NotificationService) {
  }

  ngOnInit() {
    this.roleId = sessionStorage.getItem('roleId');
    this.employeeId = sessionStorage.getItem('employeeId');
    this.name = sessionStorage.getItem('name');
    this.email = sessionStorage.getItem('email');
    this.departmentName = sessionStorage.getItem('departmentName');
    this.roleName = sessionStorage.getItem('roleName');
    this.getSideBar(this.roleId);
    this.getNotification();
    this.getNotificationCount();
    this.getData();
    this.startTimer();
    // this.initiateIdle();
  }
  logOut() {
    this.stopTimer();
    this.restService.model(`/screen/logout/${this.email}`).subscribe(data => {
      this.router.navigateByUrl(`/log-out`);
    });
  }
  getSideBar(roleId) {
    this.restService.model('/screen/GetSideBarByRole/' + roleId).subscribe((response) => {
      this.sideNav = response;
      this.navItems = this.sideNav;
    });
  }
  getNotification() {
    this.restService.model(`/notification/viewNotification/${this.employeeId}`).subscribe(notificationResponse => {
      const array = [];
      notificationResponse.forEach(element => {
        // For Time Details
        let result: string;
        const notificationTime = new Date(element.createdDate);
        const currentTime = new Date().getTime();
        const notificationDate = (currentTime - notificationTime.getTime()) / 1000;
        if (notificationDate < 59) {
          result = 'Just Now';
        } else if (notificationDate < 60) {
          result = Math.floor(notificationDate) + ' ' + 'Minute Ago';
        } else if (notificationDate < 3600) {
          result = Math.floor(notificationDate / 60) + ' ' + 'Minutes Ago';
        } else if (notificationDate < 86400) {
          result = Math.floor(notificationDate / 3600) + ' ' + 'Hour Ago';
        } else {
          result = Math.floor(notificationDate / 86400) + ' ' + 'Days Ago';
        }
        element.timeAgo = result;
        // For Link Details
        array.push(element);
      });
      this.notificationList = array;
    });
  }
  getNotificationCount() {
    this.restService.model(`/notification/unReadNotificationCount/${this.employeeId}`).subscribe(data => {
      this.notificationCount = data;
    });
  }
  getData() {
    const string = this.name.split(' ').map(function (item) {
      return item[0];
    }).join('');
    this.profileName = string.slice(0, 2);

  }
  downloadManual() {
    this.restService.model(`/master/getUserManual`).subscribe(data => {
      this.files = data;
      if (this.files.length > 0) {
        // this.fileName = this.files[0].fileName;
        this.downloadUrl = this.files[0].download;
        window.open(this.downloadUrl, "_blank");
      }
    })
  }
  startTimer() {
    this.timer = setInterval(() => {
      if (sessionStorage.getItem('employeeId') != null) {
        this.getNotification();
        this.getNotificationCount();
      } else if (sessionStorage.getItem('employeeId') == null) {
        this.stopTimer();
      }
    }, 30 * 1000);
  }
  stopTimer() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
  goToPage(id, source, refId, refNo) {
    if (source == 'Mitigation') {
      if (this.roleId == 1) {
        this.navigate(`/risk/mitigation/${refId}/${refNo}`);
      } else {
        this.restService.model(`/master/checkUser/${this.employeeId}/${refId}`).subscribe(data => {
          if (data > 0) {
            this.navigate(`/risk/mitigation/${refId}/${refNo}`);
          } else {
            this.notify.showError('UnAuthorized Access', '');
          }
        });
      }
    } else if (source == 'Risk') {
      this.navigate(`/risk/view/${refId}`);
    } else if (source == 'Incident') {
      this.navigate(`/incident/view/${refId}`);
    } else if (source == 'Control') {
      this.navigate(`/risk/controltesting/${refId}`);
    }
    this.restService.postModel(this.notificationList, `/notification/updateNotificationStatus/${id}/${this.employeeId}`).subscribe(() => {
      this.getNotification();
      this.getNotificationCount();
    });
  }

  navigate(url: any) {
    // this.router.navigateByUrl(url);
    this.router.navigateByUrl('/loading-pagezaws', { skipLocationChange: true })
      .then((data) => { this.router.navigateByUrl(url) });
  }
  // initiateIdle() {
  //   this.userIdle.startWatching();
  //   this.userIdle.onTimerStart().subscribe(count => {
  //   });
  //   this.userIdle.onTimeout().subscribe(() => {
  //     this.notify.showError('Session Expired', '');
  //     this.userIdle.stopTimer();
  //     this.userIdle.stopWatching();
  //     this.userIdle.resetTimer();
  //     this.logOut();
  //   });
  // }
}
